import { devMode } from '../../util/env'
import { buildQueryString } from '../../util/string'

import l10n from '../../shared/l10n'
const { lang } = l10n

export const LOAD_ESTATE = 'ksk001/estate/LOAD_ESTATE'
export const LOAD_ESTATE_SUCCESS = 'ksk001/estate/LOAD_ESTATE_SUCCESS'
export const LOAD_ESTATE_FAILURE = 'ksk001/estate/LOAD_ESTATE_FAILURE'

export const initialState = {
  estatesLoading: [],
  estatesLoaded: {},
  error: null,
}

export default (state = initialState, action) => {
  const { type, payload = {} } = action

  switch (type) {
    case LOAD_ESTATE:
      return {
        ...state,
        estatesLoading: [...state.estatesLoading, payload],
      }
    case LOAD_ESTATE_SUCCESS:
      return {
        ...state,
        estatesLoading: state.estatesLoading.filter(
          item => item !== payload.id
        ),
        estatesLoaded: {
          ...state.estatesLoaded,
          ...{ [payload.id]: payload },
        },
      }
    case LOAD_ESTATE_FAILURE:
      return {
        ...state,
        estatesLoading: state.estatesLoading.filter(item => item !== payload),
        error: payload.error,
      }
    default:
      return state
  }
}

export const loadEstate = id => dispatch => {
  const query = buildQueryString({
    id,
    lang,
  })

  dispatch({
    type: LOAD_ESTATE,
    payload: id,
  })

  fetch(`/wp-json/dhsv/v1/estate?${query}`)
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.statusText
          : response.status

        throw new Error(message)
      }

      response.json().then(json => {
        dispatch({
          type: LOAD_ESTATE_SUCCESS,
          payload: json,
        })
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error,
          id,
        },
        type: LOAD_ESTATE_FAILURE,
      })
      throw error
    })
}
